// extracted by mini-css-extract-plugin
module.exports = {"root":"AboutVlm_root_3r9NH"};